import { render, staticRenderFns } from "./articles-filter-group.vue?vue&type=template&id=ea183458&scoped=true"
import script from "./articles-filter-group.vue?vue&type=script&lang=js"
export * from "./articles-filter-group.vue?vue&type=script&lang=js"
import style0 from "./articles-filter-group.vue?vue&type=style&index=0&id=ea183458&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea183458",
  null
  
)

export default component.exports